<div
  class="editable-row"
  [class.editable-row--disabled]="isDisabled()"
  [class.editable-row--focused]="isFocused()"
  (click)="onContainerClick()"
>
  <span class="editable-row__general">
    @if (icon()) {
      <i class="editable-row__general-icon icon" [ngClass]="icon()"></i>
    }
    
    @if (!isFocused() && (display() || value())) {
      <span 
        class="editable-row__general-label"
        [class.editable-row__general-label--no-icon]="!icon()"
      >
        {{ hiddenInput() && value() ? '•'.repeat(value().length) : (display() || value()) }}
      </span>
    }
    
    <input
      #inputElement
      [type]="hiddenInput() ? 'password' : type()"
      class="editable-row__general-input"
      [class.editable-row__general-input--hidden]="!isFocused() && (display() || value())"
      [value]="value()"
      [placeholder]="placeholder()"
      [attr.autocomplete]="autocomplete()"
      [disabled]="isDisabled()"
      [attr.tabindex]="isDisabled() ? '-1' : '0'"
      [mask]="mask() || ''"
      [showMaskTyped]="showMaskTyped()"
      (input)="onValueChange($event)"
      (blur)="onBlur()"
      (focus)="onInputFocus()"
      (click)="onInputClick()"
      (keydown)="onKeyDown($event)"
    />
  </span>

  @if (!isFocused()) {
    <span class="editable-row__arrow">
      <i class="editable-row__arrow-icon icon icon-edit"></i>
    </span>
  }
</div>

